<ng-template vdrDialogTitle>Create new event</ng-template>

<vdr-card title="">
  <form [formGroup]="eventInfoForm" class="mt-2">
    <vdr-form-field label="Event Name" for="name">
      <input id="name" type="text" formControlName="name" />
    </vdr-form-field>
    <vdr-form-field label="Event Type" for="type">
      <input id="type" type="text" formControlName="type" />
    </vdr-form-field>
    <vdr-form-field label="Artist Name" for="artist">
      <ng-select
        [items]="artists$ | async"
        appendTo="body"
        bindLabel="name"
        [addTag]="false"
        [multiple]="false"
        [hideSelected]="true"
        [trackByFn]="trackByFn"
        [minTermLength]="0"
        [loading]="isLoading"
        [typeahead]="input$"
        formControlName="artist"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="item-row">
            <clr-icon shape="user" class="is-solid"></clr-icon
            ><span class="mx-1"> {{ item.name }}</span>
            <!-- <vdr-chip>{{ item.emailAddress }}</vdr-chip> -->
          </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="item-row">
            <clr-icon shape="user" class="is-solid"></clr-icon
            ><span class="mx-1">{{ item.name }}</span>
            <!-- <vdr-chip>{{ item.emailAddress }}</vdr-chip> -->
          </span>
        </ng-template>
      </ng-select>
    </vdr-form-field>
  </form>
</vdr-card>

<vdr-card title="Event Period">
  <form [formGroup]="eventInfoForm" class="mt-2">
    <vdr-form-field label="From" for="from">
      <vdr-datetime-picker formControlName="startDate"></vdr-datetime-picker>
    </vdr-form-field>
    <vdr-form-field label="To" for="to">
      <vdr-datetime-picker formControlName="endDate"></vdr-datetime-picker>
    </vdr-form-field>
  </form>
</vdr-card>

<vdr-card title="Winning result annoucement">
  <form [formGroup]="eventInfoForm" class="mt-2">
    <vdr-form-field label="Winning result annoucement date" for="applicationStartDate">
      <vdr-datetime-picker
        formControlName="applicationStartDate"
      ></vdr-datetime-picker>
    </vdr-form-field>
    <vdr-form-field label="Announcement Content" style="margin-top: 1rem;">
      <vdr-rich-text-editor
        formControlName="announcementContent"
      ></vdr-rich-text-editor>
    </vdr-form-field>
  </form>
</vdr-card>

<vdr-card title="Number of winners per member">
  <div class="checkbox-label">
    <input
      type="checkbox"
      name="enableIdol"
      id="enableIdol"
      [(ngModel)]="disableIdol"
    />
    <label for="enableIdol"> Number Of Winners For All Member </label>
  </div>

  <form
    [formGroup]="numberOfAllMemberForm"
    class="mt-2"
    *ngIf="disableIdol; else enableIdol"
  >
    <vdr-form-field for="numOfWinners">
      <input id="numOfWinners" type="text" formControlName="numOfWinners" />
    </vdr-form-field>
  </form>

  <ng-template #enableIdol>
    <idol-section
      [canDelete]="true"
      [isEdit]="false"
      [idols]="idols"
      (newIdolEmitter)="changeIdols($event)"
    ></idol-section>
  </ng-template>
</vdr-card>

<vdr-card title="Contact Info Type">
  <ng-select
    [items]="contactTypes"
    appendTo="body"
    bindLabel="name"
    [(ngModel)]="selectedContactType"
    [clearable]="false"
    [searchable]="false"
  >
    <ng-template ng-option-tmp let-item="item">
      <span class="item-row">
        {{ item }}
      </span>
    </ng-template>
  </ng-select>
</vdr-card>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button type="submit" (click)="save()" class="btn btn-primary">
    {{ "common.save" | translate }}
  </button>
</ng-template>
